import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";

import { CollectionUploadedParser } from "../../../../components/DirectDeposit/Transactions/CollectionUploadedParser";


export interface ICollectionUploadedParserPage { }

export const CollectionUploadedParserPage: FC<ICollectionUploadedParserPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Validation Parser"
			breadcrumbCurrentPageName=""
			// breadcrumbLinks={[]}
			mainContents={<CollectionUploadedParser />}
		/>
	);
};
